export default {
  path: '/reports/automatic-reports',
  name: 'AutomaticReports',
  component: () => import(/* webpackChunkName: "base" */ '../views/AutomaticReportsView.vue')
}
